export default {
    meta: {
        title: '加盟商详细信息',
        url: '/fishtogether/franchiseelist',
        urlName: '鱼你加盟商管理',
    }
};
